module.exports = __webpack_public_path__ + "img/thunder.f1015b7b.png";